import { useContext } from 'react';
import { GroupEntityTagsUpdateContext } from '../context';

export default function useGroupEntityTagsUpdate() {
  const value = useContext(GroupEntityTagsUpdateContext);
  return value;
}

export { useGroupEntityTagsUpdate };